import { controls } from "../../controls";

const rp201 = {
  label: "Balancing Statement",
  pageLabel: "Balancing Statement",
  starting: true,
  url: "rp201",
  pageType: "history",
  form: [],
  filter: [
    ...controls.displayText({ tab: "filter", label: "Region", width: "col-sm-2" }),
    ...controls.Region({ tab: "filter", }),
    ...controls.showData({ tab: "filter", name: "region_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Member Type", width: "col-sm-2" }),
    ...controls.MemberType({ tab: 'filter' }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", }),

    ...controls.displayText({ tab: "filter", label: "KYC Type", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter",
      name: "kyc_type", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "KYC Done",
        value: "KYC Done"
      },
      {
        label: "KYC Not Done",
        value: "KYC Not Done"
      },]
    }),
    ...controls.checkBox({ tab: "filter", label: "Without Name", name: "isWithoutName", width: "col-sm-2", }),
    ...controls.displayText({ tab: "filter", label: "GL Sub Head Group", width: "col-sm-2" }),
    ...controls.ProductGroup({ tab: 'filter', width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "PAN Type", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter",
      name: "pan_type", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "With PAN",
        value: "With PAN"
      },
      {
        label: "Without PAN",
        value: "Without PAN"
      }]
    }),

    ...controls.checkBox({ tab: "filter", label: "Print Mobile No.", name: "isPrintMobileNo", width: "col-sm-2", }),

    ...controls.displayText({ tab: "filter", label: "Product Type", width: "col-sm-2" }),
    ...controls.ProductType({
      tab: "filter",
    }),
    ...controls.showData({ tab: "filter", data: "product_type_display", width: "col-sm-2" }),



    ...controls.displayText({ tab: "filter", label: "AADHAR Type", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter",
      name: "aadhar_type", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "With AADAHAR",
        value: "With AADAHAR"
      },
      {
        label: "Without AADAHAR",
        value: "Without AADAHAR"
      },]
    }),

    ...controls.checkBox({ tab: "filter", label: "Print Member No.", name: "isPrintMemberNo", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", }),
    ...controls.showData({ tab: "filter", data: "product_code_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Type value", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter",
      name: "type_value", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Low",
        value: "Low"
      },
      {
        label: "Medium",
        value: "Medium"
      }, {
        label: "High",
        value: "High"
      }]
    }),

    ...controls.checkBox({ tab: "filter", tab: "filter", label: "Print KYC Flag", name: "isPrintKYCFlag", width: "col-sm-2" }),
    ...controls.magicDateLabel({ tab: "filter", star: true, label: "As On Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", isRequired: true, dateType: "ontype", name: "as_on_date", width: "col-sm-2", default: "sessiondate" }),

    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "SignatureType", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter",
      name: "signature_type", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "No Signature",
        value: "No Signature"
      },
      {
        label: "Single Signature",
        value: "Single Signature"
      }, {
        label: "Multiple Signature",
        value: "Multiple Signature"
      },]
    }),

    ...controls.checkBox({ tab: "filter", label: "Print AADHAR", name: "isPrintAADHAR", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Account Number From", width: "col-sm-2" }),

    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Account No From",
      name: "account_number_from",
      description: "Enter Account NumberFrom"
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Account No To",
      name: "account_number_to",
      description: "Enter Account To"
    },
    ...controls.displayText({ tab: "filter", label: "SMS Type", width: "col-sm-2" }),
    {
      inputType: "select",
      tab: "filter",
      default: "",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "With SMS",
          value: "With_SMS"
        },
        {
          label: "Without SMS",
          value: "Without_SMS"
        },
      ],
      placeHolder: "",
      name: "sms_type",
      description: "Enter Credit/Debit Type"
    },
    ...controls.checkBox({ tab: "filter", label: "Print PAN", name: "isPrintPAN", width: "col-sm-2" }),
    ...controls.displayText({ label: "Credit/Debit Type", width: "col-sm-2" }),

    {
      inputType: "select",
      default: "",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "Credit",
          value: "Credit"
        },
        {
          label: "Debit",
          value: "Debit"
        },
        {
          label: "Both",
          value: "Both"
        },
        {
          label: "Nill Balance",
          value: "Nill Balance"
        }
      ],
      placeHolder: "Credit/Debit Type",
      name: "credit_debittype",
      description: "Enter Credit/Debit Type"
    },

    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),

    {
      inputType: "checkbox",
      tab: "filter",
      default: "",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Print Risk Category",
      name: "isPrintRiskCategory",
      description: "With Print Risk Category"
    },
    ...controls.displayText({ tab: "filter", label: "Amount From To", width: "col-sm-2" }),

    {
      inputType: "numberonly",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Amount From",
      name: "amount_from",
      description: "Enter AmountFrom"
    },
    {
      inputType: "numberonly",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "AmountTo",
      name: "amount_to",
      description: "Enter Amount To"
    },
    ...controls.displayText({ tab: "filter", width: "col-sm-4" }),

    {
      inputType: "checkbox",
      tab: "filter",
      default: "",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Details",
      name: "isDetails",
      description: "Details"
    },
    ...controls.displayText({ tab: "filter", label: "Account Type", width: "col-sm-2 " }),
    ...controls.AccountType({ tab: "filter", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "account_type_display", width: "col-sm-2" }),

    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Top No Of Accounts",
      name: "",
      description: "Enter Top No Of Accounts"
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Top No Of Accounts",
      name: "top_no_of_accounts",
      description: "Enter Top No Of Accounts"
    },

  ],
  history: {
    perPage: 10,
    reportHeader: "Deposit Accounts",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [

      {
        Header: "A/C No",
        accessor: "account_number",
        width: 150
      },

      {
        Header: "CIN",
        accessor: "cin",
      },
      {
        Header: "Description",
        accessor: "description"
      },
      {
        Header: "Credit",
        accessor: "credit",
        type: "currency",
      },
      {
        Header: "Debit",
        accessor: "debit",
        type: "currency",
      },
      {
        Header: "Int Type",
        accessor: "int_flag",
      },
      {
        Header: "Interest",
        accessor: "interest",
        type: "currency",
      },
      {
        Header: "KYC",
        accessor: "kyc_flag",
        type: "tick",
        style: { fontSize: 20 }
      },
      {
        Header: "Mobile",
        accessor: "mobile",
      },
      {
        Header: "Aadhaar",
        accessor: "aadhar",
      },
      {
        Header: "PAN",
        accessor: "pan",
      },
      {
        Header: "Risk Cat",
        accessor: "risk_cat",
      },


    ]
  }
}
export default rp201;